import { ref, watch } from 'vue'
import i18n from '@web/plugins/i18n'
import { useRouter } from 'vue-router'

export function useAuthCatchErrors () {
  const router = useRouter()

  const queryError = ref('')
  function catchError (e): string {
    if (typeof e.errors === 'string') return e.errors
    if (Array.isArray(e.errors)) return e.errors.join(', ')
    if (e.errors && typeof e.errors === 'object') {
      if (e.errors.wait_seconds || e.errors.waitSeconds) {
        return e.message
      }
      const first = Object.values(e.errors as Record<string, string[] | string>)[0]
      return Array.isArray(first) ? first[0] : String(first)
    }
    return e.message
  }

  watch(router.currentRoute, (newRoute) => {
    const queryParams = newRoute.query
    const hasError = queryParams.status === 'fail' && queryParams.action === 'login' && queryParams.method === 'vkontakte'
    queryError.value = hasError ? i18n.global.t('auth.form.errorByVKID') : ''

    if (hasError) {
      router.replace({
        path: newRoute.path,
        query: {}
      })
    }
  }, {
    immediate: true,
    once: true
  })

  return {
    catchError,
    queryError
  }
}
